import { actionTypes } from 'constants/types';

export const recordActionDataAction = (data, index) => {
  let dataFormatted = { data: data, index: index };
  return {
    type: actionTypes.RECORD_AUTOMATION_DATA,
    payload: dataFormatted,
  };
};
export const resetActionDataList = () => {
  return { type: actionTypes.RESET_AUTOMATION_DATA };
};

export const resetAutomationData = () => {
  return { type: actionTypes.RESET_DATA };
};

export const setActionDataList = (data) => {
  return { type: actionTypes.SET_AUTOMATION_DATA, payload: data };
};

export const addNewCard = (cardType) => {
  return { type: actionTypes.ADD_NEW_CARD, payload: cardType };
};
export const recordActionName = (actionaNameCodeObject, index) => {
  return {
    type: actionTypes.RECORD_ACTION_TYPE,
    payload: [actionaNameCodeObject, index],
  };
};

export const setDelayOrActionBody = (body, index) => {
  return {
    type: actionTypes.RECORD_DELAY_OR_ACTION_BODY,
    payload: [body, index],
  };
};

export const setParameters = (body, index) => {
  return {
    type: actionTypes.ACTION_PARAMETERS,
    payload: [body, index],
  };
};

export const deleteCardAndBody = (index) => {
  return { type: actionTypes.DELETE_CARD_AND_DATA_BODY, payload: index };
};

export const setDataFromBackEnd = (data) => {
  return { type: actionTypes.SET_DATA_FROM_BACK_END, payload: data };
};

export const setFormIsBeingChanged = (index) => {
  return { type: actionTypes.FORM_DATA_IS_CHANGING, payload: index };
};

export const setFilterBody = (body, index) => {
  return {
    type: actionTypes.RECORD_FILTER_BODY,
    payload: [body, index],
  };
};

export const setFolderStructure = (body, index) => {
  return {
    type: actionTypes.FOLDER_STRUCTURE,
    payload: [body, index],
  };
};
